import { Vector3, Plane } from "three";
import { PLAYMODE, IMAGEDISPLAYMODE } from "../internal";
import { MeasureInfo } from "../measure/internal";
// FIXME: GeoFrameCollection <---> Stream, maybe read all video stuff for now it not here.
//        Also reverse mode. Keep in mind GeoFrameCollection is like stream, but with other initalization code,
//        -- all from geoframe.
// FIXME: After this all works, make refactor of all, since why I goods name
//        is e.g. abstract imagequadtree this is just implementation detail of subclass not a must or?
export class GeoFrameCollection {
    constructor(scene, currentgeoframe, geoframearray) {
        this.isRunning = false;
        this.cachnotreadycbf = null;
        this.cachereadycbf = null;
        this.onbuffering = null;
        this.onTileLoading = null;
        this.stoppedcbf = null;
        this.ongeoframechanged = null;
        this.setOnBuffering = function (f) {
            this.onbuffering = f;
            this.onbuffering(!this.cacheready);
        };
        this.setOnTileLoading = function (f) {
            this.onTileLoading = f;
            this.onTileLoading(!this.alltilesready);
        };
        this.setOnGeoFrameChanged = function (f) {
            this.ongeoframechanged = f;
        };
        this.scene = scene;
        this.infrascene = scene.infrascene;
        this.currentgeoframe = currentgeoframe;
        this.geoframearray = geoframearray;
        // NOTE: Why just not hard code it on geoframecollection, since you dispatch construction.
        this.type = MeasureInfo.streamtypeToNumber(currentgeoframe.type);
        // FIXME: Remove if not needed and just use currentgeoframe.getMeasureInfo()
        // if only in sublcasses, since makes easier to understand.
        this.measureinfo = currentgeoframe.getMeasureInfo();
        this.lookatfc = null;
        this.centroid = null;
        this.cacheready = false;
        this.alltilesready = true; // REVIEW: better to be false.
        this.hasloaded = false;
        // FIXME: Remove WTF!
        this.crossorigin = "use-credentials";
    }
    hide() {
        this.imagequadtree.hide = true;
    }
    show() {
        this.imagequadtree.hide = false;
    }
    setParentGeoFrameCollection(geoFrame, geoFrames) {
        geoFrame.setParentGeoFrameCollection(this);
        for (const e of geoFrames) {
            e.setParentGeoFrameCollection(this);
        }
    }
    setPanoRotationEvent(f) {
        this.onRotate = f;
    }
    getDisplayMode() {
        return this.imagequadtree.displayMode;
    }
    getImageQuadtree() {
        return this.imagequadtree;
    }
    getCurrentGeoFrame() {
        return this.currentgeoframe;
    }
    frameIndex(frame) {
        return this.geoframearray.findIndex((e) => e.id == frame.id);
    }
    // FIXME: no comment!
    searchToFramenumber(framenumber, cachingstepsize = 1) {
        if (!this.isRunning)
            this.displaymode = IMAGEDISPLAYMODE.FRAMESTEPPING;
        if (!this.cacheready && this.isRunning)
            return;
        if (this.currentgeoframe.getFramenumber() !== framenumber) {
            if (!this.isRunning)
                this.align_panoramic_view(this.currentgeoframe, this.geoframearray[framenumber]);
        }
        this.currentgeoframe = this.geoframearray[framenumber];
        this.imagequadtree.setImageIndex(framenumber, this.displaymode == IMAGEDISPLAYMODE.PLAYING && this.scene.playmode == PLAYMODE.STREAM_PLAY, cachingstepsize);
        this.scene.infrascene.render();
        return this.currentgeoframe;
    }
    getCurrentFramenumber() {
        return this.currentgeoframe.getFramenumber();
    }
    play() {
        if (!this.hasloaded)
            return;
        this.imagequadtree.forceLod0(true);
        this.displaymode = IMAGEDISPLAYMODE.PLAYING;
        this.isRunning = true;
    }
    stop() {
        if (!this.hasloaded || !this.isRunning)
            return;
        this.isRunning = false;
        this.displaymode = IMAGEDISPLAYMODE.FRAMESTEPPING;
        this.imagequadtree.forceLod0(false);
        if (this.stoppedcbf)
            this.stoppedcbf();
    }
    _imageChanged() {
        this.infrascene.sceneCamera.setPosition([
            this.currentgeoframe.easting,
            this.currentgeoframe.northing,
            this.currentgeoframe.height,
        ]);
        this.infrascene.sceneCamera.setOrientation([
            this.currentgeoframe.omega,
            this.currentgeoframe.phi,
            this.currentgeoframe.kappa,
        ]);
        this.infrascene.render();
        //determine inclination at current position for 2d-feature plane
        const idx = this.currentgeoframe ? this.frameIndex(this.currentgeoframe) : 0;
        let cidx = idx - 1;
        let nidx = idx + 1;
        // Determine inclination at current position for 2d-feature plane. FIXME: This should happen at other place since has nothing to
        // to do with image rendering
        if (idx + 1 == this.geoframearray.length) {
            cidx = idx - 1;
            nidx = idx;
        }
        if (idx == 0)
            cidx = idx;
        const p1 = new Vector3(this.geoframearray[cidx]["easting"], this.geoframearray[cidx]["northing"], this.geoframearray[cidx]["height"]);
        const p2 = new Vector3(this.geoframearray[nidx]["easting"], this.geoframearray[nidx]["northing"], this.geoframearray[nidx]["height"]);
        const v1 = p1.clone();
        v1.sub(p2);
        const n = new Vector3(v1.y, -v1.x, 0); // orthognal of v1 in 2d space
        n.cross(v1);
        p1.z = p1.z - this.currentgeoframe.getMeasureInfo().height;
        const plane = new Plane().setFromNormalAndCoplanarPoint(n, p1);
        this.infrascene.setGroundPlane(plane);
        if (this.ongeoframechanged !== null) {
            this.ongeoframechanged(this.currentgeoframe);
        }
    }
    align_panoramic_view(current_geoframe, new_geoframe, reset = false) {
        return;
    }
    getLatLon() {
        let latlon = [0, 0];
        if (this.measureinfo.tilt != null && this.measureinfo.orientation != null) {
            latlon = [this.measureinfo.tilt, this.measureinfo.orientation];
        }
        return latlon;
    }
    /**
     * Fits the image into the current canvas-size
     * @method fitToCanvas
     * @param {string?} priority Optional set the Fit-Priority to 'height' or 'width'
     */
    fitToCanvas(priority) {
        const ntiles = Math.pow(2, this.measureinfo.imagemeta.maxzoom);
        const quadtreewidth = this.measureinfo.imagemeta.tilesize * ntiles;
        const canvaswidth = this.infrascene.engine.getContextWidth();
        const canvasheight = this.infrascene.engine.getContextHeight();
        const newzoom_width = ((canvaswidth / (this.measureinfo.imagemeta.tilesize * 2)) * quadtreewidth) /
            this.measureinfo.imagemeta.width;
        const newzoom_height = ((canvasheight / (this.measureinfo.imagemeta.tilesize * 2)) * quadtreewidth) /
            this.measureinfo.imagemeta.height;
        let newzoom = newzoom_height;
        if (priority) {
            if (priority == "width")
                newzoom = newzoom_width;
        }
        else {
            if (newzoom_width > newzoom_height)
                newzoom = newzoom_width;
        }
        // Calculate mouse coords out of the max sensor coords
        const mouse_x = (this.measureinfo.imagemeta.width / quadtreewidth) * 2 * this.measureinfo.imagemeta.tilesize * newzoom;
        const mouse_y = (this.measureinfo.imagemeta.height / quadtreewidth) * 2 * this.measureinfo.imagemeta.tilesize * newzoom;
        const panX = (mouse_x - canvaswidth) / 2;
        const panY = (mouse_y - canvasheight) / 2;
        this.infrascene.quadtreeCamera.setZoomPan(newzoom, -panX, -panY);
        this.infrascene.render();
    }
    /**
     * Fits the Image (Zoom) to the given Extent in Sensor-Coordinates so that no
     * overlap ocurs.
     *
     * @method fitToExtent
     * @param {number} ulx
     * @param {number} uly
     * @param {number} lrx
     * @param {number} lry
     */
    fitToExtent(ulx, uly, lrx, lry) {
        //Be aware that zoom is not equal quadtreelevel
        const requested_width = lrx - ulx;
        const requested_height = lry - uly;
        const ntiles = Math.pow(2, this.measureinfo.imagemeta.maxzoom);
        const quadtreewidth = this.measureinfo.imagemeta.tilesize * ntiles;
        const canvaswidth = this.infrascene.engine.getContextWidth();
        const canvasheight = this.infrascene.engine.getContextHeight();
        const newzoom_width = ((canvaswidth / (this.measureinfo.imagemeta.tilesize * 2)) * quadtreewidth) / requested_width;
        let newzoom = ((canvasheight / (this.measureinfo.imagemeta.tilesize * 2)) * quadtreewidth) / requested_height;
        const widthFactor = canvaswidth / (requested_width / 8);
        const heightFactor = canvasheight / (requested_height / 8);
        if (widthFactor < heightFactor)
            newzoom = newzoom_width; //Width is limiting
        const panX = ((newzoom * -1 * ulx) / quadtreewidth) * this.measureinfo.imagemeta.tilesize * 2;
        const panY = ((newzoom * -1 * uly) / quadtreewidth) * this.measureinfo.imagemeta.tilesize * 2;
        this.infrascene.quadtreeCamera.setZoomPan(newzoom, panX, panY);
        this.infrascene.render();
    }
    static calcfuturelatlon(current_geoframe, new_geoframe, distthreshold = 50, reset = false) {
        const samesequence = current_geoframe.stream == new_geoframe.stream;
        const latlon = current_geoframe.parentGeoFrameCollection.getLatLon();
        const current_pos = current_geoframe.getPosition().slice(0, 2);
        const future_pos = new_geoframe.getPosition().slice(0, 2);
        const distance = Math.sqrt(Math.pow(future_pos[0] - current_pos[0], 2) + Math.pow(future_pos[1] - current_pos[1], 2));
        if (samesequence && distance < distthreshold) {
            return latlon;
        }
        const future_latlon = [0, 0];
        if (distance < distthreshold && !reset) {
            let current_lon = 0;
            if (["calotte", "cubemap"].indexOf(current_geoframe.type) >= 0)
                current_lon = latlon[1];
            const current_viewing_direction = current_geoframe.getHorizontalOrientation() + current_lon;
            future_latlon[1] = current_viewing_direction - new_geoframe.getHorizontalOrientation();
        }
        return future_latlon;
    }
}
//# sourceMappingURL=geoframecollection.js.map